import { AllRules } from "../ruleSets/allRules";
import { meSpeakOptions } from "../speak/meSpeak";
import { speakDefaults, speakPhonemes } from "../speak/speakPhonemes";
import { PartOptions, SpeakingPart } from "./parts";

/** run multiple parts, which can be in different languages & have different voice settings */
export class PartRunner {
  private static keepRunning = true;

  /** run a series of parts till they're done or they're stopped */
  static runParts(parts: SpeakingPart[]) {
    let i = 0;
    PartRunner.keepRunning = true;

    function nextPart() {
      if (i >= parts.length || !PartRunner.keepRunning) {
        return; // all done
      }
      const part = parts[i++];
      const language = part.language?.language ?? 'English';
      const { afterRules: ipa } = AllRules.get().convert(part.words, language, part.language?.accent);
      const lengthRules = AllRules.get().getAddPhonemeLength(language, part.language?.accent);
      const msOptions = toMespeakOptions(part.options);
      const options = msOptions ? { ...speakDefaults, ...msOptions } : speakDefaults;
      speakPhonemes(ipa, options, lengthRules, nextPart);
    }

    nextPart();
  }

  /** stop playing the current series of parts */
  static stopParts() {
    PartRunner.keepRunning = false;
    meSpeak.stop();
  }
}

/** change attributes to match what mespeak wants */
function toMespeakOptions(options?: PartOptions): meSpeakOptions | undefined {
  if (options === undefined) {
    return options;
  }
  return {
    variant: options.voice,
    amplitude: options.volume,
    pitch: options.pitch,
    speed: options.speed,
    wordgap: options.wordgap,
    pan: options.pan,
  };
}
